import React from "react";
import { Star } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../ui/carousel";
import { TESTIMONIALS } from "@/mock";

export const TestimonialsSection = () => {
    return (
        <section id="testimonials" className="py-16 bg-olive-50 relative overflow-hidden">
            <div
                className="absolute overflow-hidden z-0 left-[3%] top-0 sm:top-[5%] md:top-[-10%] w-[90vw] sm:w-[90vw] md:w-[40vw] ml-[5vw] h-[60vh] bg-no-repeat bg-bottom bg-contain pointer-events-none"
                style={{ backgroundImage: "url('/image/svg/flower.svg')" }}
            />

            <div className="mx-auto relative z-5 max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex items-end justify-between">
                    <div>
                        <h2 className="font-serif text-3xl text-olive-950">Отзывы</h2>
                        <p className="mt-2 text-olive-900/70 text-sm">Реальные истории клиентов (мок-данные).</p>
                    </div>
                    <div className="hidden md:flex items-center gap-1">
                        {[...Array(5)].map((_, i) => (
                            <Star key={i} className="w-4 h-4 fill-olive-500 text-olive-500" />
                        ))}
                    </div>
                </div>

                <Carousel className="mt-6" opts={{ align: "start" }}>
                    <CarouselContent>
                        {TESTIMONIALS.map((t) => (
                            <CarouselItem
                                key={t.id}
                                className="basis-full sm:basis-4/5 md:basis-1/3"
                            >
                                <Card className="h-full bg-white/5 backdrop-blur-sm border-olive-100">
                                    <CardContent className="p-6 flex flex-col h-full">
                                        <p className="text-olive-900/80 text-sm">"{t.text}"</p>
                                        <div className="mt-auto pt-4 text-olive-900/70 text-sm">{t.name} — {t.role}</div>
                                    </CardContent>
                                </Card>
                            </CarouselItem>
                        ))}
                    </CarouselContent>

                    <div className="mt-4 gap-2 items-center justify-start hidden md:flex">
                        <CarouselPrevious />
                        <CarouselNext />
                    </div>
                </Carousel>
            </div>
        </section>
    );
};
